import { SlidersHorizontal, Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

/**
 * M5 (#574): advanced email settings — per-partner / per-workspace send-floor
 * overrides. Shipped as a COMING-SOON stub per the epic's locked v1 decision:
 * the real feature bypasses Hermes's live-send safety floor and lands later
 * behind its own safety-gated spec. This placeholder closes the /enterprise IA
 * without touching the production send path.
 */
export function EnterpriseAdvancedEmailSettings(): JSX.Element {
  return (
    <div className="p-6 max-w-3xl">
      <Card>
        <CardHeader>
          <CardTitle className="flex flex-wrap items-center gap-2">
            <SlidersHorizontal className="h-5 w-5 text-foreground" />
            Advanced
            <Badge variant="outline" className="ml-1 gap-1 font-normal text-muted-foreground">
              <Clock className="h-3 w-3" />
              Coming soon
            </Badge>
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <p>
            Per-workspace sending controls for your enterprise — including custom
            daily send limits and send-rate overrides per workspace — are on the way.
          </p>
          <p>
            For now, every workspace in your enterprise sends under BuildIt&rsquo;s
            standard safety limits. When this lands, enterprise admins will be able to
            tune those limits per workspace from here.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
